// 安全工具模块
export class SecurityUtils {
  // 内容安全策略配置
  static getCSPConfig() {
    return {
      'default-src': ["'self'"],
      'script-src': [
        "'self'",
        "'unsafe-inline'",
        "'unsafe-eval'", // 开发环境需要
        'https://cdn.jsdelivr.net',
        'https://unpkg.com'
      ],
      'style-src': [
        "'self'",
        "'unsafe-inline'",
        'https://fonts.googleapis.com'
      ],
      'font-src': [
        "'self'",
        'https://fonts.gstatic.com',
        'data:'
      ],
      'img-src': [
        "'self'",
        'data:',
        'blob:',
        'https://*.doubao.com',
        'https://*.volcengine.com',
        'https://*.volces.com'
      ],
      'connect-src': [
        "'self'",
        'http://localhost:3001',
        'https://api.altverse.com',
        'https://api.deepseek.com',
        'https://generativelanguage.googleapis.com',
        'https://*.doubao.com',
        'https://*.volcengine.com',
        'https://*.volces.com'
      ],
      'media-src': [
        "'self'",
        'data:',
        'blob:'
      ],
      'object-src': ["'none'"],
      'base-uri': ["'self'"],
      'form-action': ["'self'"]
    }
  }

  // 输入验证和清理
  static sanitizeInput(input) {
    if (typeof input !== 'string') return input
    
    return input
      .replace(/[<>]/g, '') // 移除HTML标签
      .replace(/javascript:/gi, '') // 移除javascript协议
      .replace(/on\w+\s*=/gi, '') // 移除事件处理器
      .trim()
  }

  // 验证用户输入
  static validateInput(input, type = 'text') {
    if (!input || typeof input !== 'string') return false
    
    const patterns = {
      text: /^[\s\S]{1,1000}$/, // 普通文本，1-1000字符
      title: /^[\s\S]{1,100}$/, // 标题，1-100字符
      description: /^[\s\S]{1,500}$/, // 描述，1-500字符
      email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // 邮箱格式
      url: /^https?:\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/, // URL格式
      filename: /^[a-zA-Z0-9._-]+$/, // 文件名格式
      storyId: /^[a-f0-9-]{36}$/ // UUID格式
    }
    
    return patterns[type] ? patterns[type].test(input) : true
  }

  // 内容过滤（已禁用 - 不再过滤任何内容）
  static filterContent(content) {
    // 直接返回原内容，不进行任何过滤
    return content
  }

  // 检查文件类型
  static validateFileType(file, allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp']) {
    return allowedTypes.includes(file.type)
  }

  // 检查文件大小
  static validateFileSize(file, maxSize = 10 * 1024 * 1024) { // 默认10MB
    return file.size <= maxSize
  }

  // 生成安全的文件名
  static generateSafeFileName(originalName) {
    const timestamp = Date.now()
    const random = Math.random().toString(36).substring(2, 8)
    const extension = originalName.split('.').pop()
    return `${timestamp}_${random}.${extension}`
  }

  // 检查是否为恶意URL
  static isSafeUrl(url) {
    try {
      const urlObj = new URL(url)
      const safeProtocols = ['http:', 'https:']
      const safeHosts = ['localhost', '127.0.0.1', 'altverse.com']
      
      return safeProtocols.includes(urlObj.protocol) && 
             (safeHosts.includes(urlObj.hostname) || urlObj.hostname.endsWith('.altverse.com'))
    } catch {
      return false
    }
  }

  // 生成CSRF令牌
  static generateCSRFToken() {
    const array = new Uint8Array(32)
    crypto.getRandomValues(array)
    return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('')
  }

  // 验证CSRF令牌
  static validateCSRFToken(token, storedToken) {
    return token && storedToken && token === storedToken
  }

  // 检查存储配额
  static checkStorageQuota() {
    if ('storage' in navigator && 'estimate' in navigator.storage) {
      return navigator.storage.estimate().then(estimate => {
        const used = estimate.usage || 0
        const quota = estimate.quota || 0
        const percentage = (used / quota) * 100
        
        return {
          used,
          quota,
          percentage,
          isNearLimit: percentage > 80
        }
      })
    }
    return Promise.resolve({ used: 0, quota: 0, percentage: 0, isNearLimit: false })
  }

  // 清理敏感数据
  static sanitizeData(data) {
    if (typeof data !== 'object' || data === null) return data
    
    const sensitiveKeys = ['password', 'token', 'key', 'secret', 'auth']
    const sanitized = { ...data }
    
    Object.keys(sanitized).forEach(key => {
      if (sensitiveKeys.some(sensitive => key.toLowerCase().includes(sensitive))) {
        sanitized[key] = '[REDACTED]'
      } else if (typeof sanitized[key] === 'object') {
        sanitized[key] = this.sanitizeData(sanitized[key])
      }
    })
    
    return sanitized
  }
}

// 导出默认实例
export default SecurityUtils

